import { render, staticRenderFns } from "./node_form.vue?vue&type=template&id=1ffd5a7e&"
import script from "./node_form.vue?vue&type=script&lang=js&"
export * from "./node_form.vue?vue&type=script&lang=js&"
import style0 from "./node_form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports